<div class="support support-add">
  <button type="button"
          class="support__btn"
          [ngClass]="{'support__btn--campaign':addNewButtonVisible()}"
          (click)="openSupportDialog()"
          [matTooltip]="'Need Help'"
          matTooltipPosition="after"
          matTooltipClass="skinny-nav-link__tooltip">
    <i class="fal fa-headset"></i>
    <span class="screen-reader">Support</span>
    <span class="support__btn-label">Need help?</span>
  </button>
  <ng-container *ngIf="addNewButtonVisible()">
    <button type="button"
            class="support__btn support__btn--add-new top-add-new__btn"
            (click)="openCreateEntityDialog()">
      <i class="fal fa-plus"></i>
      <span class="support__btn-label">Add New Entity</span>
    </button>
  </ng-container>
</div>
